import {
  Examination,
  ExaminationDTO,
  mapToExamination,
} from '@higo/api/src/models/examinationDTO';
import { UserBaseDTO } from '@higo/api/src/models/userBaseDTO';
import {
  mapShareExaminationPatient,
  ShareExaminationPatient,
  ShareExaminationPatientDTO,
} from '@higo/api/src/models/shareExaminationPatientDTO';
import { PhysicalExaminationDetailsDTO } from '@higo/api/src/models/examinationDetailsDTO';
import { evolve } from 'rambda';
import { HigoMode } from './examinationPatientDTO';

export interface ExaminationDetailsWithPatientDTO {
  examination: ExaminationDTO;
  id?: number;
  executedBy: UserBaseDTO;
  patient: ShareExaminationPatientDTO;
  physicalExaminationDetails: PhysicalExaminationDetailsDTO[];
}

export interface ExaminationDetailsWithPatient
  extends Omit<ExaminationDetailsWithPatientDTO, 'examination' | 'patient'> {
  examination: Examination;
  patient: ShareExaminationPatient;
  createDate?: Date;
  status?: string;
  diagnosisId?: number;
  anamnesisPatientSurveyId?: number;
}

export const mapToExaminationDetailsWithPatient: (
  dto: ExaminationDetailsWithPatientDTO,
) => ExaminationDetailsWithPatient = evolve({
  examination: mapToExamination,
  patient: mapShareExaminationPatient,
});
